import React from "react";
import Grid from "@material-ui/core/Grid";
import { Box, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";

function displayValue(value) {
  if (value === null || value === undefined || value === "") {
    return "—";
  }
  return value;
}

const ResponsibleContact = ({
  name,
  relationship,
  tel1,
  tel2,
  email,
  birthday
}) => {
  const { t } = useTranslation();

  return (
    <Grid>
      <Box my={3} mx={2}>
        {name && (
          <Box pb={1}>
            <Typography variant="h3" gutterBottom>
              {name}
            </Typography>
          </Box>
        )}
        {relationship !== undefined && (
          <Typography variant="h4" gutterBottom>
            {t("student.contact.relationship")} 
            {' '}
            {displayValue(relationship)}
          </Typography>
        )}
        {tel1 !== undefined && (
          <Typography variant="h4" gutterBottom>
            {t("student.contact.phone1")} 
            {' '}
            {displayValue(tel1)}
          </Typography>
        )}
        {tel2 !== undefined && (
          <Typography variant="h4" gutterBottom>
            {t("student.contact.phone2")} 
            {' '}
            {displayValue(tel2)}
          </Typography>
        )}
        {email !== undefined && (
          <Typography variant="h4" gutterBottom>
            {t("student.contact.email")} 
            {' '}
            {displayValue(email)}
          </Typography>
        )}
        {birthday && (
          <Typography variant="h4">
            {t("student.contact.birthday")}
            {" "}
            {moment(birthday).format("DD/MM/YYYY")}
          </Typography>
        )}
      </Box>
    </Grid>
  );
};

ResponsibleContact.propTypes = {
  name: PropTypes.string,
  relationship: PropTypes.string,
  tel1: PropTypes.string,
  tel2: PropTypes.string,
  email: PropTypes.string,
  birthday: PropTypes.string
};

ResponsibleContact.defaultProps = {
  name: undefined,
  relationship: undefined,
  tel1: undefined,
  tel2: undefined,
  email: undefined,
  birthday: undefined
};
export default ResponsibleContact;
